import { Icon } from "@chakra-ui/react";
import { MdPerson, MdHome, MdSettings, MdCalendarMonth } from "react-icons/md";

import { FaCalendarAlt } from "react-icons/fa";
// Admin Imports
import MainDashboard from "views/admin/default";
import Profile from "views/admin/profile";

// Auth Imports
import Inventory from "views/admin/inventory";
import ScheduleLeo from "views/admin/Schedule";
import { BiPurchaseTag } from "react-icons/bi";
import PurchaseSupplier from "views/suplier/Purchase/Index";
import ScheduleSupplierLeo from "views/suplier/SchedulePurchase/Index";
import UserReports from "views/admin/rtl";

const routes = [
  {
    name: "Inicio",
    layout: "/admin",
    path: "/home",
    roles: [
      "Diretor",
      "AnalistaCompra",
      "AnalistaDistribuicao",
      "Parceiro",
      "Administrador",
      "AnalistaPlanejamento",
      "GerenteProduto",

      "AnalistaComercial",
      "AnalistaCompra",
      "Analista",
      "Assistente",
      "Loja",
      "Logistica",
    ],
    icon: <Icon as={MdHome} width="30px" height="30px" color="inherit" />,
    component: MainDashboard,
  },
  // {
  //   name: "Reagendar",
  //   layout: "/admin",
  //   path: "/nft-marketplace",
  //   icon: (
  //     <Icon
  //       as={MdOutlineShoppingCart}
  //       width="20px"
  //       height="20px"
  //       color="inherit"
  //     />
  //   ),
  //   component: NFTMarketplace,
  //   secondary: true,
  // },

  {
    name: "Agendamentos",
    layout: "/admin",
    path: "/reagendar",
    roles: [
      "Diretor",
      "AnalistaCompra",
      "AnalistaDistribuicao",
      "Parceiro",
      "Administrador",
      "AnalistaPlanejamento",
      "GerenteProduto",

      "AnalistaComercial",
      "AnalistaCompra",
      "Analista",
      "Assistente",
      "Loja",
      "Logistica",
    ],
    icon: (
      <Icon as={MdCalendarMonth} width="20px" height="20px" color="inherit" />
    ),
    component: ScheduleLeo,
  },
  {
    name: "Usuários",
    layout: "/admin",
    path: "/profile",
    roles: ["AnalistaPlanejamento", "Administrador"],
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: Profile,
  },
  {
    name: "Configurações",
    layout: "/admin",
    path: "/inventory",
    roles: ["AnalistaPlanejamento", "Logistica", "Administrador"],
    icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
    component: Inventory,
  },
  {
    name: " Pedidos",
    layout: "/supplier",
    path: "/pedidos",
    icon: (
      <Icon as={BiPurchaseTag} width="20px" height="20px" color="inherit" />
    ),
    component: PurchaseSupplier,
  },
  {
    name: " Agendamentos",
    layout: "/supplier",
    path: "/agendamentos",
    icon: (
      <Icon as={FaCalendarAlt} width="20px" height="20px" color="inherit" />
    ),
    component: ScheduleSupplierLeo,
  },
  // {
  //   name: "RTL Admin",
  //   layout: "/rtl",
  //   path: "/rtl-default",
  //   icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
  //   component: UserReports,
  // },
];

export default routes;
